import { Component, NgZone, OnInit } from '@angular/core';
import { ThreadContext } from '@freelancer/datastore/threads';
import { MessagingChat } from '@freelancer/messaging-chat';
import {
  ContextTypeApi,
  ThreadTypeApi,
} from 'api-typings/messages/messages_types';

@Component({
  selector: 'webapp-compat-messaging',
  template: `
    <app-messaging [hideMessaging]="hideMessaging"></app-messaging>
  `,
})
export class CompatMessagingComponent implements OnInit {
  hideMessaging = false;

  constructor(private messagingChat: MessagingChat, private ngZone: NgZone) {}

  ngOnInit() {
    const w = window as any;
    this.hideMessaging =
      w &&
      w.webappCompat &&
      w.webappCompat.messaging &&
      w.webappCompat.messaging.hide_messaging;
    w.liveChat = {
      startChat: (
        userIdsRaw: ReadonlyArray<number>,
        threadType: ThreadTypeApi,
        originRaw: string,
        contextRaw?: ThreadContext,
        threadIdRaw?: number,
        focus: boolean = true,
      ): void =>
        // we must make sure the code is run inside the Angular zone here since
        // that global function is called from outside Angular
        this.ngZone.run(() => {
          // As `startChat` is attached to the window, we need to be defensive
          // about what values are fed into it. In particular, this addresses
          // an issue where people had fed in strings that were numbers for
          // identifiers causing multiple chatboxes to show even though they
          // were the same thread.
          const safeParseInt = (x: any) => (x ? parseInt(x, 10) : x);
          const userIds = userIdsRaw.map(uid => safeParseInt(uid));
          const context: ThreadContext =
            contextRaw &&
            (contextRaw as any).id &&
            contextRaw.type !== ContextTypeApi.NONE
              ? {
                  type: contextRaw.type,
                  id: contextRaw.id,
                }
              : {
                  type: ContextTypeApi.NONE,
                };
          const threadId = safeParseInt(threadIdRaw);
          const origin = originRaw || '';

          this.messagingChat.startChat({
            userIds,
            threadType,
            origin,
            context,
            threadId,
            focus,
          });
        }),
      getChatboxes: () => [],
    };
  }
}
